export const SELECTORS = {
  PAGINATION: 'js-pagination',
  PAGE_BTNS: 'js-pagination-page-btns',
  PREV_BTN: 'js-pagination-prev-btn',
  NEXT_BTN: 'js-pagination-next-btn'
};

export const SCROLL_ANCHOR = '#content-block';

export const MOBILE_VISIBLE_BTN_COUNT = 3;
export const DESKTOP_VISIBLE_BTN_COUNT = 9;
